import { FC } from 'react';
import { useCmsMemberInfo } from '@doda/common/src/hooks/useCmsMemberInfo';
import { useAnalyticsSetup } from '@doda/common/src/hooks/useAnalytics';
import { BodyFooter } from '../components/Layout/bodyFooter';
import { BodyHeader } from '../components/Layout/bodyHeader';
import { PageLayout } from '../components/Layout/pageLayout';
import { MetaTag } from '../components/MetaTag';
import { PageProps } from '../index.page';
import { MainContents } from '../components/Layout/mainContents';
import { PageViewAnalytics } from '../components/PageViewAnalytics';

export const JobSearchListScreen: FC<PageProps> = ({
  sideBarProps,
  modalMasterData,
  breadCrumb,
  prBannerData,
  isShowPagination,
  seoFooterLink,
  leadSentence,
  metaTagData,
  nearAreaData,
  explainText,
  similarKeywordList,
  seoNarrowDownButtonData,
}) => {
  useCmsMemberInfo('pcHeader');
  useAnalyticsSetup({ isNeedNormalize: false });

  return (
    <>
      <PageViewAnalytics />
      <MetaTag metaTagData={metaTagData} />
      <PageLayout
        leadSentence={leadSentence}
        sideBarProps={sideBarProps}
        modalMasterData={modalMasterData}
        breadCrumb={breadCrumb}
      >
        <BodyHeader
          prBannerData={prBannerData}
          explainText={explainText}
          seoNarrowDownButtonData={seoNarrowDownButtonData}
        />
        <MainContents
          nearAreaData={nearAreaData}
          similarKeywordList={similarKeywordList}
        />
        <BodyFooter
          isShowPagination={isShowPagination}
          seoFooterLink={seoFooterLink}
          similarKeywordList={similarKeywordList}
        />
      </PageLayout>
    </>
  );
};
